module.exports = __webpack_public_path__ + "static/img/irole.08e125f.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/bz/irole.png
// module id = V1sM
// module chunks = 7